export default __webpack_public_path__ + "static/media/P2-sm-close.daa50831.svg";